// Import the global polyfill first
import './utils/globalPolyfill.js';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './assets/reset.css'
import './index.css'
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom';

createRoot(document.getElementById('root')).render(
  <BrowserRouter>
  <StrictMode>
    <App />
  </StrictMode>,
  </BrowserRouter>
)
